import CurrencyFormatter from 'currency-formatter';

const currencyFormatter = (value, opts) => CurrencyFormatter.format(value, {
  ...opts,
  locale: 'en-US',
});

export default currencyFormatter;
